import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Home, Search, ArrowLeft } from 'lucide-react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const [currency, setCurrency] = React.useState('USD');

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <PublicHeader currency={currency} onCurrencyChange={setCurrency} />
      
      <div className="flex-1 flex items-center justify-center px-4 py-16">
        <Card className="max-w-2xl w-full">
          <CardContent className="p-12 text-center">
            <div className="mb-6">
              <h1 className="text-9xl font-bold text-red-600">404</h1>
            </div>
            
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Page Not Found
            </h2>
            
            <p className="text-lg text-gray-600 mb-8">
              Sorry, the page you're looking for doesn't exist or has been moved.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                onClick={() => navigate(-1)}
                variant="outline"
                className="flex items-center gap-2"
              >
                <ArrowLeft className="h-5 w-5" />
                Go Back
              </Button>
              
              <Button
                size="lg"
                onClick={() => navigate('/')}
                className="bg-red-600 hover:bg-red-700 flex items-center gap-2"
              >
                <Home className="h-5 w-5" />
                Go to Homepage
              </Button>
              
              <Button
                size="lg"
                onClick={() => navigate('/vehicles')}
                variant="outline"
                className="flex items-center gap-2"
              >
                <Search className="h-5 w-5" />
                Browse Vehicles
              </Button>
            </div>
            
            <div className="mt-12 pt-8 border-t">
              <p className="text-sm text-gray-500">
                Need help? <a href="/contact" className="text-red-600 hover:underline">Contact us</a> or call <a href="tel:+817092702242" className="text-red-600 hover:underline">+81 70-9270-2242</a>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
      
      <PublicFooter />
    </div>
  );
};

export default NotFoundPage;
